import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_PERIODIC_AUDIT = '/dfconfigs';

export const SET_PERIODIC_AUDIT_LOADING = 'SET_PERIODIC_AUDIT_LOADING';
export const GO_TO_PERIODIC_AUDIT_EDIT = 'GO_TO_PERIODIC_AUDIT_EDIT';
export const GO_TO_PERIODIC_AUDIT_VIEW = 'GO_TO_PERIODIC_AUDIT_VIEW';
export const GO_TO_PERIODIC_AUDIT_COPY = 'GO_TO_PERIODIC_AUDIT_COPY';
export const GO_TO_PERIODIC_AUDIT_LIST = 'GO_TO_PERIODIC_AUDIT_LIST';
export const GET_PERIODIC_AUDIT_LIST = 'GET_PERIODIC_AUDIT_LIST';
export const GET_PERIODIC_AUDIT_LIST_PENDING = 'GET_PERIODIC_AUDIT_LIST_PENDING';
export const GET_PERIODIC_AUDIT_LIST_FULFILLED = 'GET_PERIODIC_AUDIT_LIST_FULFILLED';
export const GET_PERIODIC_AUDIT = 'GET_PERIODIC_AUDIT';
export const GET_PERIODIC_AUDIT_PENDING = 'GET_PERIODIC_AUDIT_PENDING';
export const GET_PERIODIC_AUDIT_FULFILLED = 'GET_PERIODIC_AUDIT_FULFILLED';
export const UPDATE_PERIODIC_AUDIT = 'UPDATE_PERIODIC_AUDIT';
export const UPDATE_PERIODIC_AUDIT_FULFILLED = 'UPDATE_PERIODIC_AUDIT_FULFILLED';
export const UPDATE_PERIODIC_AUDIT_REJECTED = 'UPDATE_PERIODIC_AUDIT_REJECTED';
export const SELECT_PERIODIC_AUDIT = 'SELECT_PERIODIC_AUDIT';

export enum PeriodicAuditPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
}

export interface PeriodicAudit {
  id: string
  NAME: string
  description: string
  CAUDTIME: string,
  CAUDPERIOD: string,
  IRICLEAR: string | boolean,
  IRIEXP: string,
  IRIEXPMNT: string,
  IRISIZE: string,
  sunday?: boolean | number | string,
  monday?: boolean | number | string,
  tuesday?: boolean | number | string,
  wednesday?: boolean | number | string,
  thursday?: boolean | number | string,
  friday?: boolean | number | string,
  saturday?: boolean | number | string,
}

export interface PeriodicAuditState {
  entities: PeriodicAudit[]
  selected: PeriodicAudit[],
  single: PeriodicAudit | null
  createdId: string | null
  ui: PeriodicAuditUIState
}

export interface PeriodicAuditUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToPeriodicAuditListAction extends AnyAction {
  type: typeof GO_TO_PERIODIC_AUDIT_LIST
}

export interface SetPeriodicAuditLoadingAction extends AnyAction {
  type: typeof SET_PERIODIC_AUDIT_LOADING
  payload: { isLoading: boolean }
}

export interface GetPeriodicAuditListAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT_LIST
  payload: AxiosPromise<ServerResponse<PeriodicAudit>>
}

export interface GetPeriodicAuditListPendingAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT_LIST_PENDING
  payload: null
}

export interface GetPeriodicAuditListFulfilledAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<PeriodicAudit>>
}

export interface GetPeriodicAuditAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT
  payload: AxiosPromise<ServerResponse<PeriodicAudit>>
}

export interface GetPeriodicAuditPendingAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT_PENDING
  payload: null
}

export interface GetPeriodicAuditFulfilledAction extends AnyAction {
  type: typeof GET_PERIODIC_AUDIT_FULFILLED
  payload: AxiosResponse<ServerResponse<PeriodicAudit>>
}

export interface UpdatePeriodicAuditThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdatePeriodicAuditAction extends AnyAction {
  type: typeof UPDATE_PERIODIC_AUDIT
  payload: AxiosPromise<ServerResponse<PeriodicAudit>>
}

export interface UpdatePeriodicAuditFulfilledAction extends AnyAction {
  type: typeof UPDATE_PERIODIC_AUDIT_FULFILLED
  payload: AxiosResponse<ServerResponse<PeriodicAudit>>
}

export interface UpdatePeriodicAuditRejectedAction extends AnyAction {
  type: typeof UPDATE_PERIODIC_AUDIT_REJECTED
  payload: AxiosResponse<ServerResponse<PeriodicAudit>>
}

export interface SelectPeriodicAuditAction extends AnyAction{
  type: typeof SELECT_PERIODIC_AUDIT
  payload: PeriodicAudit[]
}

export type PeriodicAuditActionTypes =
  GoToPeriodicAuditListAction |
  SetPeriodicAuditLoadingAction |
  GetPeriodicAuditListAction |
  GetPeriodicAuditListPendingAction |
  GetPeriodicAuditListFulfilledAction |
  GetPeriodicAuditAction |
  GetPeriodicAuditPendingAction |
  GetPeriodicAuditFulfilledAction |
  UpdatePeriodicAuditAction |
  UpdatePeriodicAuditFulfilledAction |
  UpdatePeriodicAuditRejectedAction |
  SelectPeriodicAuditAction;
